/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

export const onClientEntry = () => {
  if (!window.pushDL) {
    window.pushDL = (eventName, params = {}) => {
      window.dataLayer.push({
        event: eventName,
        page_path: window.location.pathname,
        page_title: document?.title,
        ...params,
      });
    };
  }

  // SPA-safe scroll depth tracking
  let __scrollDepthFired = new Set();
  const __scrollDepthThresholds = [25, 50, 75, 90];

  const __emitScrollDepthIfNeeded = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    const docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    ) - window.innerHeight;

    if (docHeight <= 0) return;

    const percent = Math.round((scrollTop / docHeight) * 100);
    __scrollDepthThresholds.forEach((t) => {
      if (percent >= t && !__scrollDepthFired.has(t)) {
        __scrollDepthFired.add(t);
        window.pushDL?.('scroll_depth', {
          scroll_depth: t,
        });
      }
    });
  };

  const __onScroll = () => {
    __emitScrollDepthIfNeeded();
  };

  window.addEventListener('scroll', __onScroll, { passive: true });

  // Expose a reset hook for route changes
  window.__resetScrollDepth = () => {
    __scrollDepthFired = new Set();
    // Recalculate immediately (helps short pages register 25% at load)
    __emitScrollDepthIfNeeded();
  };
};

export const onRouteUpdate = () => {
  // Reset thresholds per virtual pageview
  window.__resetScrollDepth?.();
};
